import Vue from 'vue';
import Element from 'element-ui';
import locale from 'element-ui/lib/locale/lang/zh-CN'; // lang i18n
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(Element, { locale, size: 'small' });
